const initialState = {
    data: null,
}
export const sendFeedBackEmailReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SENDFEEDBACKEMAIL_SUCCESS':
            return {
                ...state,
                data: action.payload,
            };
        case 'SENDFEEDBACKEMAIL_FAILURE':
            return {
                ...state,
                error: action.payload
            };
        default:
            return state;
    }
}

export default sendFeedBackEmailReducer;